var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFocusGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.05,13.12H30.74a2.43,2.43,0,0,0,2.44-2.43V2.44A2.44,2.44,0,0,0,30.74,0H16.05a2.44,2.44,0,0,0-2.44,2.44v8.25a2.44,2.44,0,0,0,2.44,2.43m.1-10.58H30.64v8H16.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.84,28.33H19A1.91,1.91,0,0,0,17,30.24v5.09A1.92,1.92,0,0,0,19,37.24h8.89a1.91,1.91,0,0,0,1.91-1.91V30.24a1.9,1.9,0,0,0-1.91-1.91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.88,28.33H36a1.9,1.9,0,0,0-1.91,1.91v5.09A1.91,1.91,0,0,0,36,37.24h8.89a1.91,1.91,0,0,0,1.91-1.91V30.24a1.9,1.9,0,0,0-1.91-1.91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.8,28.33H1.91A1.91,1.91,0,0,0,0,30.24v5.09a1.92,1.92,0,0,0,1.91,1.91H10.8a1.91,1.91,0,0,0,1.91-1.91V30.24a1.9,1.9,0,0,0-1.91-1.91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.74,13.83a1.27,1.27,0,1,0,0,2.54h9.31a1.27,1.27,0,1,0,0-2.54Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.51,38.09H21.28a1.27,1.27,0,1,0,0,2.54h4.23a1.27,1.27,0,1,0,0-2.54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.47,38.09H4.24a1.27,1.27,0,0,0,0,2.54H8.47a1.27,1.27,0,1,0,0-2.54"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.55,38.09H38.32a1.27,1.27,0,0,0,0,2.54h4.23a1.27,1.27,0,1,0,0-2.54"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.36,26.21a1.27,1.27,0,0,0,1.27-1.27,3.82,3.82,0,0,1,3.81-3.81H22.13v3.81a1.27,1.27,0,0,0,2.54,0V21.13H35.35a3.81,3.81,0,0,1,3.81,3.81,1.28,1.28,0,0,0,2.55,0,6.36,6.36,0,0,0-6.36-6.35H11.44a6.36,6.36,0,0,0-6.35,6.35,1.27,1.27,0,0,0,1.27,1.27"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.4,4.23a2.33,2.33,0,1,0,2.32,2.33A2.33,2.33,0,0,0,23.4,4.23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusGroupIcon);
export default __webpack_public_path__ + "static/media/FocusGroupIcon.5dd8e9ab2909e26079dfd623d06e79dd.svg";
export { ForwardRef as ReactComponent };